import React from 'react';
import PropTypes from 'prop-types';

// components
import AssuranceIcon from 'dibs-vg/dist/react/buyer-assurance';
import PdpSharedBlurb from './PdpSharedBlurb/PdpSharedBlurb';
import { learnMore } from '../pdpMessages';
import { buyerProtectionTitle, buyerProtectionText } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import tracking from 'dibs-tracking';

function trackLinkClick() {
    tracking.trackEvent({
        action: 'buyer protection',
        label: 'clicked',
        category: 'product',
    });
}

export default function PdpSharedBlurbBuyerProtection() {
    return (
        <PdpSharedBlurb Icon={AssuranceIcon}>
            <span className={styles.title}>{buyerProtectionTitle}: </span>
            {buyerProtectionText}
            <div>
                <a
                    data-tn="buyer-protection-link"
                    onClick={trackLinkClick}
                    href="/about/promise/"
                    target="_blank"
                >
                    {learnMore}
                </a>
            </div>
        </PdpSharedBlurb>
    );
}

PdpSharedBlurbBuyerProtection.propTypes = {
    userId: PropTypes.string,
};
